export const CLINIC = {
  name: "Nehchal Eye Centre",
  doctor: "Dr. Gurkiran Kaur",
  doctorTitle: "Fellowship Trained Ophthalmologist",
  phone: "+91 9711511001",
  phoneRaw: "+919711511001",
  whatsappUrl:
    "https://wa.me/919711511001?text=Hello%2C%20I%20would%20like%20to%20book%20an%20appointment%20with%20Dr.%20Gurkiran%20Kaur.",
  email: "info@nehchaleye.com",
  address: {
    line1: "10, Marigold Court, Wave City Centre",
    line2: "Sector 32, Noida",
    state: "Uttar Pradesh",
    postal: "201301",
    country: "India",
    countryCode: "IN",
    region: "UP",
    locality: "Noida",
  },
  geo: { lat: 28.5806, lng: 77.3236 },
  hours: [
    { day: "Monday", open: "09:00", close: "19:00" },
    { day: "Tuesday", open: "09:00", close: "19:00" },
    { day: "Wednesday", open: "09:00", close: "19:00" },
    { day: "Thursday", open: "09:00", close: "19:00" },
    { day: "Friday", open: "09:00", close: "19:00" },
    { day: "Saturday", open: "09:00", close: "19:00" },
    { day: "Sunday", open: "10:00", close: "13:00" },
  ],
  mapUrl:
    "https://maps.google.com/?q=10,+Marigold+court,+Wave+city+centre,+sector+32+Noida",
  mapsEmbedUrl:
    "https://www.google.com/maps?q=10%20Marigold%20Court%20Wave%20City%20Centre%20Sector%2032%20Noida&output=embed",
  logo: "https://customer-assets-v7afamib.emergentagent.net/job_cataract-seo-noida/artifacts/juyfcelq_CLINICLOGO.jpg",
  doctorPhoto:
    "https://customer-assets.emergentagent.com/job_b2da92d6-6478-4579-ac21-14239f453dc4/artifacts/3wgrvayz_IMG_1090.PNG",
  facilityPhotos: [
    {
      url: "https://customer-assets.emergentagent.com/job_b2da92d6-6478-4579-ac21-14239f453dc4/artifacts/z8ac6tnq_CLINIC1.webp",
      alt: "Examination room at Nehchal Eye Centre Noida with slit lamp and auto refractometer",
      title: "Examination Room",
      caption: "Advanced diagnostic equipment including slit lamp and auto refractometer",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_b2da92d6-6478-4579-ac21-14239f453dc4/artifacts/5goeoyom_CLINIC2.jpg",
      alt: "State-of-the-art operation theatre at Nehchal Eye Centre in Sector 32 Noida",
      title: "State-of-the-Art OT",
      caption: "Modern operation theatre with advanced surgical microscope",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_b2da92d6-6478-4579-ac21-14239f453dc4/artifacts/cu20gjaq_CLINIC5.jpg",
      alt: "Reception and waiting area at Nehchal Eye Centre Noida",
      title: "Reception & Waiting",
      caption: "Comfortable reception and waiting areas for patient convenience",
    },
    {
      url: "https://customer-assets.emergentagent.com/job_b2da92d6-6478-4579-ac21-14239f453dc4/artifacts/s0rimh7u_CLINIC6.jpg",
      alt: "Nehchal Eye Centre clinic building exterior in Wave City Centre Noida",
      title: "Clinic Exterior",
      caption: "Our modern clinic building located in Wave City Centre, Noida",
    },
  ],
  googleReviewsUrl: "https://www.google.com/search?q=Nehchal+Eye+Centre+Noida+reviews",
  googleMapsCid: "https://maps.google.com/?cid=748708233202041890",
  reviewCount: 176,
  ratingValue: "5.0",
  testimonials: [
    {
      name: "Mrs. Sunita Sharma",
      role: "Cataract Surgery Patient • Age 68",
      rating: 5,
      source: "Website",
      text: "Dr. Gurkiran Kaur performed my cataract surgery with such precision and care. I can see clearly again! Her expertise and the modern facility made me feel completely confident. Highly recommended!",
    },
    {
      name: "Mr. Rajesh Kumar",
      role: "Comprehensive Eye Care • Age 45",
      rating: 5,
      source: "Website",
      text: "Exceptional service from start to finish! The team is professional, the clinic is state-of-the-art, and Dr. Kaur's knowledge is incredible. My family now trusts only Nehchal Eye Centre.",
    },
    {
      name: "Ms. Priya Agarwal",
      role: "Oculoplasty Procedure • Age 52",
      rating: 5,
      source: "Website",
      text: "I was nervous about my eyelid surgery, but Dr. Gurkiran's gentle approach and detailed explanations put me at ease. The results are amazing! I look and feel more confident now.",
    },
    {
      name: "Vicky Arya",
      role: "Verified Google Review",
      rating: 5,
      source: "Google",
      text: "Really nice service, ambience and staff and doctor. Highly recommend Nehchal Eye Centre for anyone in Noida looking for professional eye care.",
    },
    {
      name: "Vishal Yadav",
      role: "Verified Google Review",
      rating: 5,
      source: "Google",
      text: "Visited the clinic for a regular eye check-up and had a good experience overall. Clean set-up, thorough examination, and honest advice — exactly what you want from an eye doctor.",
    },
    {
      name: "Jasdeep Singh Malhotra",
      role: "Verified Google Review",
      rating: 5,
      source: "Google",
      text: "The doctor was knowledgeable and addressed the symptoms appropriately. Took time to explain everything clearly — did not feel rushed at any point during the visit.",
    },
    {
      name: "Anita Verma",
      role: "Dry Eye Treatment • Age 41",
      rating: 5,
      source: "Google",
      text: "I had chronic dry eyes for years. Dr. Kaur properly investigated the cause and put me on a structured treatment plan — the difference in three weeks was remarkable. Wish I had come here sooner.",
    },
    {
      name: "Rohit Sethi",
      role: "Periocular rejuvenation • Age 38",
      rating: 5,
      source: "Google",
      text: "Went in for crow's feet treatment. Dr. Kaur explained everything, the procedure was gentle, and the result looks natural — not frozen. Will definitely be back for maintenance.",
    },
    {
      name: "Meera Chauhan",
      role: "Pediatric Eye Care (Parent)",
      rating: 5,
      source: "Google",
      text: "Took my 4-year-old for his first eye exam. The team is patient with kids, made him comfortable, and gave us honest, no-pressure advice. Highly recommend for families in Sector 32.",
    },
  ],
};
